import { API_BASE_URL } from "../assets/const";
import { checkAndUpdateToken } from "./auth";
import { GET_STUDY_PLANS, GET_SUBJECT_BY_YEAR_STUDY, GET_SUBJECT_BY_YEAR_STUDY_COURSES } from "./types";
import { buildDefaultHeaders } from "./helper";
import { createNotification } from "../components/Notifications/Notifications";

export const getStudyPlans = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/library/courses/tracks`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GET_STUDY_PLANS, payload: data.data });
    }
  }
};

export const getSubjectsByYearStudy = (trid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/subjects_by_year_study?trid=${trid}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GET_SUBJECT_BY_YEAR_STUDY, payload: data.data });
    }
  }
};

export const getSubjectsByYearStudyCourses = (trid, level) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: GET_SUBJECT_BY_YEAR_STUDY_COURSES, payload: null });
    const response = await fetch(`${API_BASE_URL}/subjects_by_year_study/courses?trid=${trid}&level=${level}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GET_SUBJECT_BY_YEAR_STUDY_COURSES, payload: data.data });
    }
  }
};

export const saveSubjectsByYearStudy = ({ trid, level, cid_list }) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/subjects_by_year_study`, {
      method: "PUT",
      ...buildDefaultHeaders(getState),
      body: JSON.stringify({ trid, level, cid_list }),
    });
    if (response.ok) {
      createNotification('success', 'Состав года обучения сохранён');
      await dispatch(getSubjectsByYearStudy(trid));
      return true;
    }
    createNotification('error', 'Не удалось сохранить состав года обучения');
  }
  return false;
};
